/* Web Push helpers — subscribe/unsubscribe via VAPID */
import { api } from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function ensureServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  const existing = await navigator.serviceWorker.getRegistration("/sw.js");
  return existing || (await navigator.serviceWorker.register("/sw.js", { scope: "/" }));
}

export async function getPushStatus() {
  if (!pushSupported()) return { supported: false, permission: "denied", subscribed: false };
  const reg = await ensureServiceWorker();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return { supported: true, permission: Notification.permission, subscribed: !!sub, endpoint: sub?.endpoint || null };
}

export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Push notifications not supported in this browser");
  const perm = Notification.permission === "granted" ? "granted" : await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notification permission denied");
  const { data } = await api.get("/push/public-key");
  if (!data.public_key) throw new Error("Push not configured on the server");
  const reg = await ensureServiceWorker();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  const raw = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: raw.endpoint,
    keys: raw.keys || {},
    ua: navigator.userAgent,
  });
  return raw.endpoint;
}

export async function unsubscribeFromPush() {
  const reg = await ensureServiceWorker();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  if (sub) {
    const endpoint = sub.endpoint;
    try { await sub.unsubscribe(); } catch (e) {}
    try { await api.post("/push/unsubscribe", { endpoint }); } catch (e) {}
  }
}
